/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener("DOMContentLoaded", function () {
  // Functie om tekst nodes te vinden en te vervangen
  const findAndReplaceText = function (element) {
    // Doorloop alle child nodes
    if (element.childNodes && element.childNodes.length > 0) {
      element.childNodes.forEach((node) => {
        // Als het een tekstnode is en "QUANTITY_" bevat
        if (node.nodeType === 3 && node.textContent.includes("QUANTITY_")) {
          // Vervang alleen het "QUANTITY_XXX" gedeelte, behoud de rest
          const newText = node.textContent.replace(
            /QUANTITY_[^(]*/g,
            "Bulkkorting "
          );
          node.textContent = newText;
        } else if (node.nodeType === 1) {
          // Als het een element is, doorzoek recursief
          findAndReplaceText(node);
        }
      });
    }
  };

  // Zoek zowel de main cart als mini-cart discount elementen
  const discountElements = document.querySelectorAll(
    ".line-item__discount-list, .mini-cart__discount"
  );
  discountElements.forEach(findAndReplaceText);

  // Extra controle voor specifieke mini-cart elementen
  const miniCartItems = document.querySelectorAll(
    ".mini-cart__discount-list, .mini-cart__discount"
  );
  miniCartItems.forEach(findAndReplaceText);

  // Observeer DOM-veranderingen voor dynamisch geladen elementen
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            // Element node
            const discounts = node.querySelectorAll(
              ".line-item__discount-list, .mini-cart__discount, .mini-cart__discount-list"
            );
            discounts.forEach(findAndReplaceText);
          }
        });
      }
    });
  });

  // Start observatie op het hele document
  observer.observe(document.body, { childList: true, subtree: true });
});

document.addEventListener("DOMContentLoaded", function () {
  // Aangepaste countdown functie voor meerdere elementen
  function startCountdowns() {
    // Zoek alle countdown elementen
    const countdownElements = document.querySelectorAll(
      ".countdown-timer, #countdown"
    );

    if (countdownElements.length === 0) return; // Stop als er geen elementen zijn

    // Check of het vandaag zaterdag is
    const today = new Date();
    const day = today.getDay();
    const isSaturday = day === 0 || day === 5 || day === 6 || day === 4; // vrijdag, zaterdag, zondag

    if (!isSaturday) {
      // Als het geen zaterdag is, verberg de countdown elementen
      countdownElements.forEach((el) => {
        const parentBanner = el.closest(".product-meta__text");
        if (parentBanner) {
          parentBanner.style.display = "none";
        } else {
          el.style.display = "none";
        }
      });
      return;
    }

    // Stel einddatum in op het einde van de huidige zaterdag (23:59:59)
    const endOfToday = new Date(today);
    endOfToday.setHours(23, 59, 59, 999);
    const countdownDate = endOfToday.getTime();

    var x = setInterval(function () {
      var now = new Date().getTime();
      var distance = countdownDate - now;

      if (distance < 0) {
        clearInterval(x);
        return;
      }

      var hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      var countdownText = hours + "u " + minutes + "m " + seconds + "s ";

      // Update alle countdown elementen
      countdownElements.forEach((el) => {
        el.innerHTML = countdownText;
      });
    }, 1000);
  }

  // Start de countdowns
  startCountdowns();
});

/**
 * Format price in cents using shop's money format
 * @param {number} cents - Price in cents
 * @returns {string} Formatted price
 */
function formatMoney(cents) {
  if (typeof cents !== "number") {
    cents = parseFloat(cents) || 0;
  }

  const moneyFormat =
    window.theme && window.theme.moneyFormat
      ? window.theme.moneyFormat
      : "€{{amount}}";
  const value = (cents / 100).toFixed(2);

  return moneyFormat
    .replace("{{amount}}", value)
    .replace("{{amount_with_comma_separator}}", value.replace(".", ","));
}

/**
 * Product Add-ons Cart Integration
 * Handles adding selected product add-ons to cart after main product is added

document.addEventListener("DOMContentLoaded", function () {
  // Initialize quantity selectors for add-ons
  initializeQuantitySelectors();
});
 */
/**
 * Listen for existing cart add events and add add-ons afterwards
 * This approach is more compatible with existing theme functionality
 */
document.addEventListener("product:added", function (event) {
  // Only proceed if the main product was successfully added
  if (!event.detail.productAdded) {
    return;
  }

  // Small delay to ensure main product is fully processed
  setTimeout(async function () {
    const selectedAddons = window.getSelectedAddons();

    if (selectedAddons.length > 0) {
      try {
        await window.addItemsToCart(selectedAddons);

        // Trigger cart refresh to update UI after add-ons are added
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
          })
        );
      } catch (error) {
        console.error("Failed to add add-ons:", error);

        // Show error message to user if available
        if (window.theme && window.theme.showQuickToast) {
          window.theme.showQuickToast(
            "Add-ons konden niet worden toegevoegd aan de winkelwagen",
            "error"
          );
        }
      }
    }
  }, 300); // Reduced delay for better UX
});

/**
 * Get the main product quantity from the product form
 */
function getMainProductQuantity() {
  const formElement = document.querySelector('form[action*="/cart/add"]');
  if (!formElement) return 1;

  const quantityInput = formElement.querySelector('[name="quantity"]');
  const quantity = quantityInput ? parseInt(quantityInput.value) : 1;
  return quantity > 0 ? quantity : 1;
}

// Global helper functions for add-ons functionality
window.getSelectedAddons = function () {
  const selectedAddons = [];
  const mainQuantity = getMainProductQuantity();

  // Find all checked add-on checkboxes
  const checkedAddons = document.querySelectorAll(
    ".rts-checkbox-button:checked"
  );

  checkedAddons.forEach((checkbox) => {
    const productId = checkbox.getAttribute("data-product-id");
    const variantId = checkbox.getAttribute("data-variant-id");
    const quantityMode = checkbox.getAttribute("data-quantity-mode");
    const basePrice =
      parseFloat(checkbox.getAttribute("data-variant-base-price")) || 0;
    const checkboxId = checkbox.id;
    const addonQuantityAttr = checkbox.getAttribute("data-addon-quantity");

    if (productId && variantId) {
      let quantity = 1;

      // Calculate quantity based on quantity mode
      if (quantityMode === "main-q_per_addon-q") {
        const mainPerAddon = parseInt(addonQuantityAttr) || 1;
        // Calculate addon quantity: divide main quantity by "main per addon"
        // Example: 10 main / 5 per addon = 2 addon quantity
        quantity = Math.ceil(mainQuantity / mainPerAddon);

        // Update displayed price based on calculated quantity
        const newPrice = quantity * basePrice;
        const priceElement = document.querySelector(
          `[data-price-for="${checkboxId}"]`
        );
        if (priceElement) {
          priceElement.textContent = '+ ' + formatMoney(newPrice);
        }
      } else if (quantityMode === "match_main") {
        // Match the main product quantity
        quantity = mainQuantity;
      } else if (quantityMode === "fixed") {
        // Use fixed quantity from data attribute
        quantity = parseInt(addonQuantityAttr) || 1;
      } else {
        // Fallback to data-addon-quantity or 1
        quantity = parseInt(addonQuantityAttr) || 1;
      }

      selectedAddons.push({
        id: variantId,
        quantity: quantity,
        product_id: productId,
      });
    }
  });

  return selectedAddons;
};

window.addItemsToCart = async function (items) {
  if (!items || items.length === 0) return;

  try {
    const response = await fetch(window.routes.cartAddUrl + ".js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({
        items: items,
      }),
    });

    if (!response.ok) {
      throw new Error("Failed to add items to cart");
    }

    const result = await response.json();

    return result;
  } catch (error) {
    console.error("Error adding add-ons to cart:", error);
    throw error;
  }
};

/**
 * Update addon prices based on current main product quantity
 * Only updates prices for addons with 'main-q_per_addon-q' quantity mode
 */
function updateAddonPrices() {
  const mainQuantity = getMainProductQuantity();

  // Find all addon checkboxes with dynamic pricing
  const addonsWithDynamicPricing = document.querySelectorAll(
    '.rts-checkbox-button[data-quantity-mode="main-q_per_addon-q"]'
  );

  addonsWithDynamicPricing.forEach((checkbox) => {
    const checkboxId = checkbox.id;
    const basePrice =
      parseFloat(checkbox.getAttribute("data-variant-base-price")) || 0;
    const addonQuantityAttr = checkbox.getAttribute("data-addon-quantity");
    const mainPerAddon = parseInt(addonQuantityAttr) || 1;

    // Calculate addon quantity: divide main quantity by "main per addon"
    // Example: 10 main / 5 per addon = 2 addon quantity
    const quantity = Math.ceil(mainQuantity / mainPerAddon);
    const newPrice = quantity * basePrice;

    // Update the price display
    const priceElement = document.querySelector(
      `[data-price-for="${checkboxId}"]`
    );
    if (priceElement) {
      priceElement.textContent = '+ ' + formatMoney(newPrice);
    }
  });
}

/**
 * Listen for quantity changes on the main product
 * Uses event delegation to work with dynamically loaded elements
 */
document.addEventListener("DOMContentLoaded", function () {
  // Use event delegation on document body for better compatibility
  document.body.addEventListener("change", function(event) {
    // Check if the changed element is a quantity input
    if (event.target.matches('form[action*="/cart/add"] [name="quantity"]')) {
      updateAddonPrices();
    }
  });

  document.body.addEventListener("input", function(event) {
    // Check if the input element is a quantity input
    if (event.target.matches('form[action*="/cart/add"] [name="quantity"]')) {
      updateAddonPrices();
    }
  });

  // Also try direct event listener approach (fallback)
  const formElement = document.querySelector('form[action*="/cart/add"]');
  if (formElement) {
    const quantityInput = formElement.querySelector('[name="quantity"]');
    if (quantityInput) {
      quantityInput.addEventListener("change", updateAddonPrices);
      quantityInput.addEventListener("input", updateAddonPrices);
    }
  }

  // Initial price update
  setTimeout(updateAddonPrices, 100);
});

/**
 * Product Add-ons State Management
 * Saves and restores checkbox states when variant changes
 */
document.addEventListener("DOMContentLoaded", function () {
  initializeAddonStates();
});

// Save and restore states when variant changes
document.addEventListener("variant:changed", function () {
  // Save current checked states before re-initialization
  const savedStates = saveAddonStates();

  // Small delay to ensure DOM is updated with new variant's add-ons
  setTimeout(() => {
    // Restore checked states
    restoreAddonStates(savedStates);
    // Update addon prices for the new variant
    updateAddonPrices();
  }, 100);
});

function initializeAddonStates() {
  // Initialization if needed for future functionality
}

/**
 * Save current addon checked states
 */
function saveAddonStates() {
  const states = {};

  document.querySelectorAll(".rts-checkbox-button").forEach((checkbox) => {
    const variantId = checkbox.getAttribute("data-variant-id");
    if (variantId) {
      states[variantId] = {
        checked: checkbox.checked,
      };
    }
  });

  return states;
}

/**
 * Restore addon checked states
 */
function restoreAddonStates(savedStates) {
  if (!savedStates) return;

  document.querySelectorAll(".rts-checkbox-button").forEach((checkbox) => {
    const variantId = checkbox.getAttribute("data-variant-id");
    if (variantId && savedStates[variantId]) {
      checkbox.checked = savedStates[variantId].checked;
    }
  });
}

/**
 * Pill Dropdown Variant Selector
 * Custom dropdown UI voor kleur selectie met chips
 * Provides enhanced UX for color/variant selection with visual color swatches
 */
(function() {
  'use strict';

  class PillDropdown {
    constructor(wrapper) {
      // Skip if already initialized
      if (wrapper.dataset.pillDropdownInitialized === 'true') return;

      this.wrapper = wrapper;
      this.select = wrapper.querySelector('.pill-dropdown__select');
      this.selected = wrapper.querySelector('.pill-dropdown__selected');
      this.list = wrapper.querySelector('.pill-dropdown__list');

      if (!this.select || !this.selected || !this.list) return;

      this.options = this.list.querySelectorAll('.pill-dropdown__option');
      this.init();

      wrapper.dataset.pillDropdownInitialized = 'true';
    }

    init() {
      this.bindEvents();
      this.updateSelected();
    }

    bindEvents() {
      // Toggle dropdown on selected display click
      this.selected.addEventListener('click', this.toggleDropdown.bind(this));

      // Prevent default select behavior and toggle custom UI
      this.select.addEventListener('mousedown', (e) => {
        e.preventDefault();
        this.toggleDropdown();
      });

      // Sync native select changes to custom UI
      this.select.addEventListener('change', () => {
        this.updateSelected();
        this.close();
      });

      // Keyboard navigation
      this.select.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.toggleDropdown();
        } else if (e.key === 'Escape') {
          this.close();
        }
      });

      // Custom option clicks
      this.options.forEach(option => {
        option.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();

          if (option.classList.contains('is-disabled')) return;

          const value = option.getAttribute('data-value');
          this.select.value = value;
          this.select.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });

      // Close dropdown when clicking outside
      this.outsideClickHandler = (e) => {
        if (!this.wrapper.contains(e.target)) {
          this.close();
        }
      };
      document.addEventListener('click', this.outsideClickHandler);
    }

    toggleDropdown() {
      const isOpen = this.wrapper.classList.toggle('is-open');
      this.selected.setAttribute('aria-expanded', isOpen.toString());
    }

    close() {
      this.wrapper.classList.remove('is-open');
      this.selected.setAttribute('aria-expanded', 'false');
    }

    updateSelected() {
      const selectedOption = this.select.options[this.select.selectedIndex];
      const selectedText = selectedOption.textContent.trim();
      const chipStyle = selectedOption.getAttribute('data-chip-style') || '';

      const chip = this.selected.querySelector('.pill-swatch__chip');
      const text = this.selected.querySelector('.pill-swatch__text');

      if (chip) chip.setAttribute('style', chipStyle);
      if (text) text.textContent = selectedText;

      // Update option states in custom list
      this.options.forEach(opt => {
        opt.classList.toggle('is-selected',
          opt.getAttribute('data-value') === selectedOption.value
        );
      });
    }

    destroy() {
      if (this.outsideClickHandler) {
        document.removeEventListener('click', this.outsideClickHandler);
      }
    }
  }

  /**
   * Initialize all pill dropdowns on the page
   * Only initializes elements that haven't been initialized yet
   */
  function initPillDropdowns() {
    document.querySelectorAll('.select-wrapper--pill-dropdown:not([data-pill-dropdown-initialized])').forEach(wrapper => {
      new PillDropdown(wrapper);
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPillDropdowns);
  } else {
    initPillDropdowns();
  }

  // Re-initialize on variant changes (consistent with addon state management pattern)
  // Uses same 100ms delay as addon code to ensure ProductRerender has updated DOM
  document.addEventListener('variant:changed', function() {
    setTimeout(initPillDropdowns, 100);
  });

})();

/**
 * Automatische gratis-koeltas (free gift)
 * ----------------------------------------
 * Voegt het in de theme-settings gekozen gratis product (€0) automatisch toe
 * zodra de cart de drempel haalt, en verwijdert het weer zodra de cart eronder
 * zakt. Config wordt door layout/theme.liquid in window.RTS_FREE_GIFT gezet
 * (alleen aanwezig als de feature aan staat én er een beschikbaar product is).
 *
 * Werkt zonder Cart Transform Function: puur client-side via de Ajax Cart API.
 * Beperking: synct alleen op getheme-de pagina's met JS (page load + cart-events).
 * De koeltas is €0, dus telt niet mee in cart.total_price — de drempelcheck blijft
 * dus zuiver op de "echte" producten.
 */
(function () {
  'use strict';

  var config = window.RTS_FREE_GIFT;

  // Niets te doen: feature uit, geen product gekozen, of in de theme editor
  // (auto-toevoegen tijdens previewen is ongewenst).
  if (!config || !config.variantId || !config.thresholdCents) return;
  if (window.Shopify && window.Shopify.designMode) return;

  // De module leunt volledig op de Ajax Cart API-routes. Ontbreken die (bv. een
  // template die window.routes niet zet), dan kan er niets gesynct worden:
  // expliciet loggen i.p.v. later een vage TypeError in de catch.
  var routes = window.routes;
  if (!routes || !routes.cartUrl || !routes.cartAddUrl || !routes.cartChangeUrl) {
    console.error('Free gift sync uitgeschakeld: window.routes ontbreekt of is onvolledig.');
    return;
  }

  var isSyncing = false;
  // Een cart-event dat binnenkomt terwijl er al een sync loopt wordt niet
  // genegeerd maar onthouden: na afloop draaien we één extra pass zodat altijd
  // tegen de laatste cart-staat gereconcilieerd wordt (bv. een quantity-wijziging
  // die midden in de fetch landt).
  var pendingSync = false;
  // Zodra een add structureel faalt (bv. gift-product niet verkoopbaar → 422)
  // stoppen we met herproberen op elk cart-event; anders blijft elke rerender
  // een falende add afvuren. Reset zodra de cart onder de drempel zakt, zodat
  // een echte her-kwalificatie het opnieuw probeert.
  var addBlocked = false;

  // Voert een cart-mutatie uit en meldt een niet-ok response expliciet, zodat een
  // mislukte add/remove niet stil wegvalt terwijl de UI "verdiend" blijft tonen.
  async function mutateCart(url, body, label) {
    try {
      var res = await ajax(url, body);
      if (res.ok) return true;
      var detail = await res.text().catch(function () { return '(geen body)'; });
      console.error(
        'Free gift ' + label + ' faalde:', res.status, detail, 'variant', config.variantId
      );
      return false;
    } catch (error) {
      console.error('Free gift ' + label + ' faalde (netwerk):', error);
      return false;
    }
  }

  function ajax(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    });
  }

  function refreshCartUI() {
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { scrollToTop: false },
      })
    );
  }

  async function syncFreeGift() {
    if (isSyncing) {
      pendingSync = true;
      return;
    }
    isSyncing = true;

    try {
      var res = await fetch(routes.cartUrl + '.js', {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      if (!res.ok) {
        console.error('Free gift sync: /cart.js gaf', res.status, '— reconciliatie overgeslagen.');
        return;
      }

      var cart = await res.json();
      // Defensief: een onverwacht antwoord (HTML-foutpagina met 200, lege body)
      // mag niet stil verkeerd evalueren of throwen.
      if (!Array.isArray(cart.items) || typeof cart.total_price !== 'number') {
        console.error('Free gift sync: onverwachte cart-vorm, reconciliatie overgeslagen.', cart);
        return;
      }

      var giftLine = cart.items.find(function (item) {
        return item.variant_id === config.variantId;
      });

      // De koeltas is gratis en telt dus niet mee in total_price; de drempel
      // wordt zuiver op de overige producten beoordeeld.
      var eligible = cart.total_price >= config.thresholdCents;

      // Onder de drempel → een eerdere add-blokkade is niet meer relevant; bij
      // her-kwalificatie mag de add opnieuw geprobeerd worden.
      if (!eligible) addBlocked = false;

      if (eligible && !giftLine && !addBlocked) {
        // Drempel gehaald, koeltas nog niet in cart → toevoegen.
        var added = await mutateCart(routes.cartAddUrl + '.js', {
          id: config.variantId,
          quantity: 1,
        }, 'add');
        if (added) refreshCartUI();
        // Structurele fout (bv. niet-verkoopbaar gift-product): niet bij elk
        // cart-event blijven herproberen.
        else addBlocked = true;
      } else if (!eligible && giftLine) {
        // Onder de drempel gezakt → koeltas verwijderen.
        var removed = await mutateCart(routes.cartChangeUrl + '.js', {
          id: giftLine.key,
          quantity: 0,
        }, 'remove');
        if (removed) refreshCartUI();
      } else if (giftLine && giftLine.quantity > 1) {
        // Veiligheidsnet: nooit meer dan 1 gratis koeltas.
        var fixed = await mutateCart(routes.cartChangeUrl + '.js', {
          id: giftLine.key,
          quantity: 1,
        }, 'fix-quantity');
        if (fixed) refreshCartUI();
      }
    } catch (error) {
      console.error('Free gift sync onverwacht gefaald:', error, 'variant', config.variantId);
    } finally {
      isSyncing = false;
      // Tijdens deze sync een nieuw cart-event gemist? Draai er precies één extra
      // pass voor, tegen de dan-actuele cart-staat.
      if (pendingSync) {
        pendingSync = false;
        syncFreeGift();
      }
    }
  }

  // Trigger 1: na een product-add (dit event bubbelt wél naar document).
  document.addEventListener('product:added', syncFreeGift);

  // Trigger 2: na elke cart-rerender. Cart._rerender dispatcht `cart:rerendered`
  // op het Cart-element (.header__action-item--cart): op de cart-pagina mét
  // bubbles, maar in de mini-cart drawer ZONDER bubbles. Een document-listener
  // mist daardoor de mini-cart updates. We binden daarom direct op het
  // Cart-element zelf — dat is in beide gevallen het event-target. (#mini-cart is
  // een child van dat element en zou het non-bubbling event nooit ontvangen.)
  function bindCartRerender() {
    var cartElement = document.querySelector('.header__action-item--cart');
    if (cartElement) cartElement.addEventListener('cart:rerendered', syncFreeGift);
  }

  function init() {
    bindCartRerender();
    // Page-load catch-up voor carts die al kwalificeren (of een koeltas bevatten
    // die er niet meer hoort) zonder dat er een cart-actie plaatsvond. De
    // server-gerenderde staat zit al in de config (cartTotalCents + giftQuantity),
    // dus we zoeken het netwerk alleen op als die staat niet klopt — geen
    // overbodige /cart.js fetch op elke page load.
    var total = config.cartTotalCents;
    var giftQuantity = config.giftQuantity || 0;
    var eligible = typeof total === 'number' && total >= config.thresholdCents;
    var inconsistent = (eligible && giftQuantity !== 1) || (!eligible && giftQuantity > 0);
    if (inconsistent) syncFreeGift();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/**
 * Bezorg cart attributes
 * ----------------------------------------
 * Zet de cart attributes "bezorgroute", "bezorg_type" en "verzendmethode" op
 * basis van de cart-inhoud, berekend server-side door
 * sections/cart-attribute-calc.liquid (variant-metafields
 * fulfillment_system.length_transport en shipping.max_quantity_per_box +
 * gewicht per regel + PIR-tag). Checkout Blocks gebruikt de attributes om de
 * groot-transport instructies te tonen en verzendmethodes te verbergen.
 *
 * De section levert een object met één entry per attribute:
 *   { "bezorgroute":    { "value": ..., "current": ... },
 *     "bezorg_type":    { "value": ..., "current": ... },
 *     "verzendmethode": { "value": ..., "current": ... } }
 * De sleutels zijn de attribute-namen, dus een attribute toevoegen kan
 * voortaan in de Liquid alleen — deze module hoeft niet mee.
 *
 * Let op: bezorg_type kan meerdere waarden bevatten, komma-gescheiden,
 * bv. "zending-lengte,zending-pallet". verzendmethode is altijd één waarde.
 *
 * Triggers spiegelen de free-gift module: product:added + cart:rerendered
 * (direct op het Cart-element gebonden, want non-bubbling in de drawer).
 * Dekt daarmee ook de cart-mutaties van de add-ons en free-gift modules,
 * die na hun eigen add/remove een cart:refresh -> rerender veroorzaken.
 * Er wordt bewust geen cart:refresh gedispatcht na de attribute-update: de
 * attributes zijn niet zichtbaar in de cart-UI, en een refresh zou een
 * onnodige extra rerender-cyclus veroorzaken.
 *
 * Fail-open: alles in deze module mag falen zonder de checkout te blokkeren.
 * De verberg-regels in Checkout Blocks verbergen alleen op bekende waarden,
 * dus een leeg of verouderd attribute toont hooguit te veel verzendmethodes.
 */
(function () {
  'use strict';

  if (window.Shopify && window.Shopify.designMode) return;

  var SECTION = 'cart-attribute-calc';
  var FETCH_TIMEOUT_MS = 8000; // per request; voorkomt dat een hangende fetch de sync voorgoed blokkeert
  var GUARD_TIMEOUT_MS = 4000; // maximale wachttijd van de checkout-guard

  var isSyncing = false;
  var pendingSync = false;
  var currentPass = Promise.resolve();

  // Locale-aware root ("/" of bv. "/nl-be/"), met fallback.
  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  // Shopify geeft een niet-gezet attribute terug als null; normaliseer beide
  // kanten naar een string zodat null en '' niet als wijziging tellen.
  function normalize(value) {
    return value === null || value === undefined ? '' : String(value);
  }

  function fetchWithTimeout(url, options) {
    if (typeof AbortController === 'undefined') return fetch(url, options);
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, FETCH_TIMEOUT_MS);
    var opts = Object.assign({}, options, { signal: controller.signal });
    return fetch(url, opts).finally(function () { clearTimeout(timer); });
  }

  // Eén sync-pass: section renderen, vergelijken, zo nodig attributes updaten.
  // Gooit nooit; fouten worden gelogd.
  async function runPass() {
    try {
      var res = await fetchWithTimeout(root() + '?sections=' + SECTION);
      if (!res.ok) {
        console.error('Bezorg-attributes sync: section render gaf', res.status);
        return;
      }
      var html = (await res.json())[SECTION];
      if (!html) {
        console.error('Bezorg-attributes sync: section "' + SECTION + '" niet gevonden in gepubliceerd theme.');
        return;
      }
      var el = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector('[data-cart-attr]');
      if (!el) {
        console.error('Bezorg-attributes sync: [data-cart-attr] element ontbreekt in section-output.');
        return;
      }

      var data = JSON.parse(el.textContent);

      // Bouw de volledige set attributes op en kijk of er iets wijzigt.
      // Entries die geen { value, current } object zijn worden overgeslagen,
      // zodat een oude section-versie hooguit een no-op oplevert.
      var attributes = {};
      var changed = false;

      Object.keys(data).forEach(function (key) {
        var entry = data[key];
        if (!entry || typeof entry !== 'object') return;

        var next = normalize(entry.value);
        if (next !== normalize(entry.current)) changed = true;
        attributes[key] = next;
      });

      if (!changed) return;

      var update = await fetchWithTimeout(root() + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ attributes: attributes }),
      });
      if (!update.ok) {
        console.error('Bezorg-attributes sync: update.js gaf', update.status);
      }
    } catch (error) {
      console.error('Bezorg-attributes sync faalde:', error);
    }
  }

  // Geeft een promise terug die pas resolved als de cart-staat van NU verwerkt
  // is. Komt er tijdens een lopende pass een mutatie bij, dan draait dezelfde
  // promise nog een extra pass tegen de dan-actuele staat. Dat is nodig voor
  // de checkout-guard: die mag niet doorgaan na de oude pass terwijl de
  // inhaal-pass nog loopt.
  function syncCartAttribute() {
    if (isSyncing) {
      pendingSync = true;
      return currentPass;
    }
    isSyncing = true;

    currentPass = (async function () {
      try {
        do {
          pendingSync = false;
          await runPass();
        } while (pendingSync);
      } finally {
        isSyncing = false;
      }
    })();

    return currentPass;
  }

  // Checkout-guard: een klant die direct na een quantity-wijziging op afrekenen
  // klikt mag niet met stale attributes de checkout in. We onderscheppen de
  // klik, wachten op de sync (maximaal GUARD_TIMEOUT_MS), en spelen de klik
  // daarna opnieuw af via een data-flag zodat de guard zichzelf niet opnieuw
  // triggert.
  function bindCheckoutGuard() {
    var guardBusy = false;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[name="checkout"], a[href="/checkout"], a[href^="/checkout?"]');
      if (!btn) return;
      if (btn.dataset.bezorgrouteSynced === 'true') {
        delete btn.dataset.bezorgrouteSynced;
        return;
      }
      e.preventDefault();
      e.stopPropagation();

      // Dubbelklik tijdens het wachten: negeren, de eerste klik wordt afgespeeld.
      if (guardBusy) return;
      guardBusy = true;

      var timeout = new Promise(function (resolve) {
        setTimeout(resolve, GUARD_TIMEOUT_MS);
      });

      Promise.race([syncCartAttribute(), timeout]).then(function () {
        guardBusy = false;
        // De drawer kan tijdens het wachten opnieuw gerenderd zijn; een knop
        // die niet meer in de DOM zit submit niets meer.
        if (!btn.isConnected) {
          window.location.href = root() + 'checkout';
          return;
        }
        btn.dataset.bezorgrouteSynced = 'true';
        btn.click();
      });
    }, true);
  }

  function bindCartRerender() {
    // Zelfde binding als de free-gift module: direct op het Cart-element,
    // omdat cart:rerendered in de mini-cart drawer niet bubbelt.
    var cartElement = document.querySelector('.header__action-item--cart');
    if (cartElement) {
      cartElement.addEventListener('cart:rerendered', function () {
        syncCartAttribute();
      });
    }
  }

  document.addEventListener('product:added', function () {
    syncCartAttribute();
  });

  function init() {
    bindCartRerender();
    bindCheckoutGuard();
    // Page-load catch-up: de cart-pagina reload na elke wijziging, dus hier is
    // de staat altijd vers; ook dekt dit carts uit een eerdere sessie en
    // corrigeert het attributes die door een afgebroken sync stale bleven.
    syncCartAttribute();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();